/*eslint-disable*/ export const messages = {
    "Go to the first page": "Перейти на первую страницу",
    "Go to the last page": "Перейти на последнюю страницу",
    "Pagination, showing {from} through {to} of {total} entities": [
        "На странице: ",
        ["from"],
        "–",
        ["to"],
        " из ",
        ["total"],
    ],
    "Show next {entitiesPerPage} entities": ["Показать след. ", ["entitiesPerPage"]],
    "Show previous {entitiesPerPage} entities": ["Показать пред. ", ["entitiesPerPage"]],
    "{from} through {to} of {total}": [["from"], "–", ["to"], " из ", ["total"]],
    "{from}-{to} of {total}": [["from"], "–", ["to"], " из ", ["total"]],
};
